import { getData, postData, putData, deleteData } from "../apiClient";

// get flights with pagination
export const getFlightsWithPagination = async ({ page = 1, limit = 10, search = "", from_date = "", to_date = "", date_column = "" }, signal = null) => {
    try {
        const queryParams = new URLSearchParams({
            page: String(page),
            limit: String(limit),
            search: search,
            from_date: from_date,
            to_date: to_date,
            date_column: date_column,
        });

        const result = await getData(`/flight-management/flights?${queryParams}`, {}, {}, signal);
        return {
            success: true,
            ...result,
        };
    } catch (error) {
        console.error("Get Flight with pagination API error:", error);
        return {
            success: false,
            ...error,
        };
    }
};

// get flight data with id
export const getFlightDataWithId = async (id) => {
    try {
        const result = await getData(`/flight-management/flight/${id}`);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error("Get Flight data API error:", error);
        return {
            data: {
                success: false,
                error: error.message,
            },
        };
    }
};

// create flight 
export const createFlight = async ({ data }) => {
    try {
        const result = await postData(`/flight-management/add-flight`, data);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Flight add API error:", error);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.data.error : error.message,
                status: error.status,
            },
        };
    }
};

// update flight data
export const updateFlight = async ({ id, data }) => {
    try {
        const result = await putData(`/flight-management/update-flight/${id}`, data);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Flight API error:", error.status === 400 ? error.error : error.message);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
};

// delete flight
export const deleteFlight = async ({ id }) => {
    try {
        const result = await deleteData(`/flight-management/delete-flight/${id}`);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Flight API error:", error.status === 400 ? error.error : error.message);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
};
